import { endOfDay, parseISO, startOfDay } from 'date-fns';

import $api from 'http/index';
import { getOptions } from 'helpers/getOptions';
import { geoLocationsActions } from './geoLocationsSlice';

const BASE = `${process.env.REACT_APP_BASE_URL}/geo-locations`;

export const PAGE_SIZE = 25;

const errorMessage = (error) => error?.response?.data?.message || error?.message || 'Request failed';

// Filters are calendar days; the BE compares instants, so send each set bound in the user's zone.
// An unset bound is omitted entirely — that is what makes an unfiltered purge delete everything.
const rangeParams = ({ from, to }) => ({
  ...(from && { from: startOfDay(parseISO(from)).toISOString() }),
  ...(to && { to: endOfDay(parseISO(to)).toISOString() }),
});

// An empty sortBy keeps the BE on its cheap default-ordered pipeline instead of the in-memory sort.
const sortParams = ({ sortBy, sortOrder }) => (sortBy ? { sortBy, sortOrder } : {});

export const fetchGeoLocations =
  ({ append } = {}) =>
  async (dispatch, getState) => {
    const { filters, rows } = getState().geoLocations;
    dispatch(geoLocationsActions.fetchStarted());
    try {
      const { data } = await $api.get(BASE, {
        ...getOptions(),
        params: {
          userId: filters.userId,
          ...rangeParams(filters),
          ...sortParams(filters),
          skip: append ? rows.length : 0,
          limit: PAGE_SIZE,
        },
      });
      dispatch(
        geoLocationsActions.fetchSucceeded({
          rows: data,
          hasMore: data.length === PAGE_SIZE,
          append,
        })
      );
    } catch (error) {
      dispatch(geoLocationsActions.fetchFailed(errorMessage(error)));
    }
  };

export const fetchGeoLocationUsers = () => async (dispatch, getState) => {
  try {
    const { data } = await $api.get(`${BASE}/users`, {
      ...getOptions(),
      params: rangeParams(getState().geoLocations.filters),
    });
    dispatch(geoLocationsActions.usersLoaded(data));
  } catch (error) {
    dispatch(geoLocationsActions.fetchFailed(errorMessage(error)));
  }
};

export const purgeGeoLocations =
  ({ username, password }) =>
  async (dispatch, getState) => {
    const { filters } = getState().geoLocations;
    dispatch(geoLocationsActions.purgeStarted());
    try {
      await $api.post(
        `${BASE}/purge`,
        { username, password, userId: filters.userId, ...rangeParams(filters) },
        getOptions()
      );
      dispatch(geoLocationsActions.purgeFinished());
      await dispatch(fetchGeoLocations());
    } catch (error) {
      dispatch(geoLocationsActions.purgeFinished());
      // Rethrown so the dialog stays open and renders the message inline.
      throw error;
    }
  };
